// src/lib/veille-api.js — la veille, côté écran. LECTURE SEULE.
//
// Une seule action, sans paramètre : la veille argent est une vue admin, et
// n'expose aucun levier. Il n'y a volontairement AUCUNE fonction d'écriture
// dans ce fichier — les gestes sur la caution vivent dans l'écran de la
// réservation, sous les gardes du chemin argent.

import { supabase } from "../supabase";

async function lire(action) {
  const { data: { session } } = await supabase.auth.getSession();
  const res = await fetch(`/api/beds24-mapping?action=${action}`, {
    method: "GET",
    headers: { Authorization: `Bearer ${session?.access_token || ""}` },
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(json?.error || `${action}_echouee`);
  return json;
}

export function fetchVeilleCautions() {
  return lire("veille_cautions");
}

export function fetchVeilleManques() {
  return lire("veille_manques");
}

/**
 * « Fait ailleurs » — taire une alerte, ou retirer un silence.
 * SEULE écriture de ce fichier. Zéro argent, zéro message.
 */
export async function poserSilenceVeille({ famille, cle, periode, motif, retirer }) {
  const { data: { session } } = await supabase.auth.getSession();
  const res = await fetch("/api/beds24-mapping?action=veille_silence", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${session?.access_token || ""}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ famille, cle, periode, motif, retirer: !!retirer }),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || json.ok === false) throw new Error(json?.error || "silence_echoue");
  return json;
}
